import { Component, Prop, h } from '@stencil/core';
import { IconOptions } from '../icon/svg';

export enum TextLinkSize {
  xs = 'xs',
  s = 's',
  m = 'm',
}

export enum TextLinkIconPosition {
  start = 'start',
  end = 'end',
}

@Component({
  tag: 'amp-text-link',
  styleUrls: ['../../base.css', 'textLink.css'],
  shadow: true,
})
export class AmpTextLink {
  /**
   * The URL destination when clicking the link
   */
  @Prop() href: string;
  /**
   * Size: xs, s, m (default)
   */
  @Prop() size: string;
  /**
   * An Icon component to display
   */
  @Prop() icon: IconOptions;
  /**
   * Position of the icon component
   */
  @Prop() iconPosition: TextLinkIconPosition;
  /**
   * Underline on hover
   */
  @Prop() underlineHover: boolean;
  /**
   * Comes from the 3rd piece of the tracking code that is selected on the content type
   */
  @Prop() dataCampaignName: string;
  /**
   * The entire tracking code that merch/marketing use for reporting purposes
   */
  @Prop() dataAnalyticsTrackingId: string;

  render() {
    const linkHref = this.href;
    const linkSize = this.size || TextLinkSize.m;
    const linkIcon = this.icon;
    const linkIconPosition = this.iconPosition || TextLinkIconPosition.end;
    const linkUnderlineHover = this.underlineHover || true;
    const dataCampaignName = this.dataCampaignName;
    const dataAnalyticsTrackingId = this.dataAnalyticsTrackingId;

    let linkClass;

    switch (linkSize) {
      case TextLinkSize.xs:
        linkClass = 'text-xs';
        break;
      case TextLinkSize.s:
        linkClass = 'text-sm';
        break;
      case TextLinkSize.m:
        linkClass = 'text-base';
        break;
      default:
        linkClass = 'text-base';
    }

    return (
      <a
        class={`inline-flex items-center text-primary font-semibold ${linkClass}`}
        href={linkHref}
        data-campaign-name={dataCampaignName ? dataCampaignName : null}
        data-analytics-trackingid={dataAnalyticsTrackingId ? dataAnalyticsTrackingId : null}
      >
        {linkIcon && linkIconPosition === TextLinkIconPosition.start && <amp-icon svg={linkIcon} width="20" height="20" />}
        <span class={`${linkUnderlineHover && `py-[0.5px] border-transparent border-b-[1px] hover:border-primary`}`}>
          <slot />
        </span>
        {linkIcon && linkIconPosition === TextLinkIconPosition.end && <amp-icon svg={linkIcon} width="20" height="20" />}
      </a>
    );
  }
}
